import { LocalDiningHistoryRecord } from '../useLocalDiningHistory';

// fake restaurants generated with an LLM
export const mockResponses: LocalDiningHistoryRecord[] = [
    {
        transactionDateTime: '2024-01-01',
        organizationBenefitAmount: '$5.25',
        transactionId: '1234567890',
        merchantName: "Joe's Diner",
        transactionAmount: '$35.00',
    },
    {
        transactionDateTime: '2024-01-02',
        organizationBenefitAmount: '$3.80',
        transactionId: '1234567891',
        merchantName: 'Taco Haven',
        transactionAmount: '$22.50',
    },
    {
        transactionDateTime: '2024-01-03',
        organizationBenefitAmount: '$6.40',
        transactionId: '1234567892',
        merchantName: 'Bella Pasta',
        transactionAmount: '$42.75',
    },
    {
        transactionDateTime: '2024-01-04',
        organizationBenefitAmount: '$4.25',
        transactionId: '1234567893',
        merchantName: 'Sushi Zen',
        transactionAmount: '$30.00',
    },
    {
        transactionDateTime: '2024-01-05',
        organizationBenefitAmount: '$7.50',
        transactionId: '1234567894',
        merchantName: 'Burger Barn',
        transactionAmount: '$50.00',
    },
    {
        transactionDateTime: '2024-01-06',
        organizationBenefitAmount: '$5.75',
        transactionId: '1234567895',
        merchantName: 'Pizza Palace',
        transactionAmount: '$38.25',
    },
    {
        transactionDateTime: '2024-01-07',
        organizationBenefitAmount: '$2.90',
        transactionId: '1234567896',
        merchantName: 'Healthy Bites',
        transactionAmount: '$19.95',
    },
    {
        transactionDateTime: '2024-01-08',
        organizationBenefitAmount: '$4.90',
        transactionId: '1234567897',
        merchantName: 'Steakhouse 101',
        transactionAmount: '$32.40',
    },
    {
        transactionDateTime: '2024-01-09',
        organizationBenefitAmount: '$3.60',
        transactionId: '1234567898',
        merchantName:
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore commodi necessitatibus, odio est iusto ut? Eveniet laborum officiis harum unde mollitia fugiat adipisci! Error inventore sint, at amet voluptate cium!',
        transactionAmount: '$24.00',
    },
    {
        transactionDateTime: '2024-01-09',
        organizationBenefitAmount: '$3.60',
        transactionId: '1234567898',
        merchantName: 'Curry Corner',
        transactionAmount: '$24.00',
    },
    {
        transactionDateTime: '2024-01-10',
        organizationBenefitAmount: '$6.10',
        transactionId: '1234567899',
        merchantName: 'BBQ Nation',
        transactionAmount: '$45.00',
    },
    {
        transactionDateTime: '2024-01-10',
        organizationBenefitAmount: '$6.10',
        transactionId: '1234567899',
        merchantName:
            ' BBQ Nation BBQ Nation BBQ Nation BBQ Nation BBQ Nation BBQ Nation BBQ Nation BBQ Nation BBQ Nation BBQ Nation',
        transactionAmount: '$45.00',
    },
    {
        transactionDateTime: '2024-01-11',
        organizationBenefitAmount: '$5.20',
        transactionId: '1234567900',
        merchantName: 'The Green Fork',
        transactionAmount: '$36.75',
    },
    {
        transactionDateTime: '2024-01-12',
        organizationBenefitAmount: '$3.40',
        transactionId: '1234567901',
        merchantName: 'Submarine Subs',
        transactionAmount: '$21.50',
    },
    {
        transactionDateTime: '2024-01-13',
        organizationBenefitAmount: '$8.10',
        transactionId: '1234567902',
        merchantName: 'Fancy Feast',
        transactionAmount: '$60.00',
    },
    {
        transactionDateTime: '2024-01-14',
        organizationBenefitAmount: '$4.00',
        transactionId: '1234567903',
        merchantName: 'Pancake House',
        transactionAmount: '$28.90',
    },
    {
        transactionDateTime: '2024-01-15',
        organizationBenefitAmount: '$5.65',
        transactionId: '12345679043',
        merchantName: 'Taco Time',
        transactionAmount: '$37.80',
    },
    {
        transactionDateTime: '2024-01-15',
        organizationBenefitAmount: '$5.65',
        transactionId: '1234567904',
        merchantName:
            'Taco Time Taco Time Taco Time Taco Time Taco Time Taco Time Taco Time Taco Time Taco Time Taco Time Taco Time Taco Time Taco Time',
        transactionAmount: '$37.80',
    },
    {
        transactionDateTime: '2024-01-16',
        organizationBenefitAmount: '$3.90',
        transactionId: '1234567905',
        merchantName: 'Mediterranean Delights',
        transactionAmount: '$26.00',
    },
    {
        transactionDateTime: '2024-01-17',
        organizationBenefitAmount: '$6.75',
        transactionId: '1234567906',
        merchantName: 'Gourmet Burgers',
        transactionAmount: '$48.90',
    },
    {
        transactionDateTime: '2024-01-18',
        organizationBenefitAmount: '$2.80',
        transactionId: '1234567907',
        merchantName: 'Quick Bites',
        transactionAmount: '$18.25',
    },
    {
        transactionDateTime: '2024-01-19',
        organizationBenefitAmount: '$7.00',
        transactionId: '1234567908',
        merchantName: 'The Seafood Spot',
        transactionAmount: '$52.40',
    },
    {
        transactionDateTime: '2024-01-20',
        organizationBenefitAmount: '$4.50',
        transactionId: '1234567909',
        merchantName: 'Comfort Kitchen',
        transactionAmount: '$34.20',
    },
];
